package com.ervasstudio.tracoemovimento.pages.cursos.login

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import com.ervasstudio.tracoemovimento.components.custumcomponents.layout.GoogleLoginButton
import com.ervasstudio.tracoemovimento.model.GoogleUser
import com.ervasstudio.tracoemovimento.util.Res
import com.ervasstudio.tracoemovimento.util.Res.MyColors.Lilas
import com.ervasstudio.tracoemovimento.util.Res.MyColors.PretoDesfalecido
import com.ervasstudio.tracoemovimento.util.Res.MyColors.SurfaceContent
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.graphics.Colors.White
import com.varabyte.kobweb.compose.ui.modifiers.alignItems
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.justifyContent
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.minHeight
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.right
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.top
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.forms.Input
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.AlignItems
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.JustifyContent
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.position
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.vh
import org.jetbrains.compose.web.css.width
import org.jetbrains.compose.web.dom.Div

@Composable
fun Login(
    email: String,
    onEmailChange: (String) -> Unit,
    senha: String,
    onSenhaChange: (String) -> Unit,
    naoTenhoContaClick: () -> Unit,
    onEntrarClick: () -> Unit,
    externalError: String? = null,
    errorMessage: String? = null,
    emailError: String? = null,
    senhaError: String? = null,
    emailErrorChange: (String?) -> Unit,
    senhaErrorChange: (String?) -> Unit,
    isLoging: Boolean = false,
    isLogingChange: (Boolean) -> Unit,
    onGoogleLoginButtonClick: (GoogleUser) -> Unit,
    isMobile: Boolean,
) {
    if (isMobile) {
        LoginMobile(
            email, onEmailChange, senha, onSenhaChange, naoTenhoContaClick, onEntrarClick,
            externalError, emailError, senhaError, emailErrorChange, senhaErrorChange,
            isLoging, isLogingChange, onGoogleLoginButtonClick,
        )
    } else {
        LoginDesktop(
            email, onEmailChange, senha, onSenhaChange, naoTenhoContaClick, onEntrarClick,
            externalError, emailError, senhaError, emailErrorChange, senhaErrorChange,
            isLoging, isLogingChange, onGoogleLoginButtonClick,
        )
    }
}

@Composable
private fun LoginDesktop(
    email: String,
    onEmailChange: (String) -> Unit,
    senha: String,
    onSenhaChange: (String) -> Unit,
    naoTenhoContaClick: () -> Unit,
    onEntrarClick: () -> Unit,
    externalError: String?,
    emailError: String?,
    senhaError: String?,
    emailErrorChange: (String?) -> Unit,
    senhaErrorChange: (String?) -> Unit,
    isLoging: Boolean,
    isLogingChange: (Boolean) -> Unit,
    onGoogleLoginButtonClick: (GoogleUser) -> Unit,
) {
    Row(
        modifier = Modifier.fillMaxWidth().minHeight(100.vh).gap(10.cssRem),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.Center,
    ) {
        Column(
            modifier = Modifier.weight(1f).fillMaxHeight(),
            horizontalAlignment = Alignment.End,
            verticalArrangement = Arrangement.Center
        ) {
            Image(
                src = Res.Image.tracoemovultra,
                alt = "Traço Movimento",
                modifier = Modifier.width(320.px)
            )
        }

        Column(
            modifier = Modifier.weight(1f).fillMaxHeight(),
            horizontalAlignment = Alignment.Start,
            verticalArrangement = Arrangement.Center
        ) {
            LoginFormContent(
                email, onEmailChange, senha, onSenhaChange, naoTenhoContaClick, onEntrarClick,
                externalError, emailError, senhaError, emailErrorChange, senhaErrorChange,
                isLoging, isLogingChange, onGoogleLoginButtonClick,
                isMobile = false,
            )
        }
    }
}

@Composable
private fun LoginMobile(
    email: String,
    onEmailChange: (String) -> Unit,
    senha: String,
    onSenhaChange: (String) -> Unit,
    naoTenhoContaClick: () -> Unit,
    onEntrarClick: () -> Unit,
    externalError: String?,
    emailError: String?,
    senhaError: String?,
    emailErrorChange: (String?) -> Unit,
    senhaErrorChange: (String?) -> Unit,
    isLoging: Boolean,
    isLogingChange: (Boolean) -> Unit,
    onGoogleLoginButtonClick: (GoogleUser) -> Unit,
) {
    Column(
        modifier = Modifier
            .fillMaxWidth()
            .minHeight(100.vh)
            .padding(leftRight = 20.px, topBottom = 24.px),
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.Center,
    ) {
        Image(
            src = Res.Image.tracoemovultra,
            alt = "Traço Movimento",
            modifier = Modifier.width(140.px)
                .margin(bottom = 24.px)
        )

        LoginFormContent(
            emailError = emailError,
            onEmailChange = onEmailChange,
            senha = senha,
            onSenhaChange = onSenhaChange,
            naoTenhoContaClick = naoTenhoContaClick,
            onEntrarClick = onEntrarClick,
            externalError = externalError,
            email = email,
            senhaError = senhaError,
            emailErrorChange = emailErrorChange,
            senhaErrorChange = senhaErrorChange,
            isLoging = isLoging,
            isLogingChange = isLogingChange,
            onGoogleLoginButtonClick = onGoogleLoginButtonClick,
            isMobile = true,
        )
    }
}

private fun inputModifier() = Modifier
    .fillMaxWidth()
    .height(48.px)
    .borderRadius(24.px)
    .border(1.px, LineStyle.Solid, Colors.Black)
    .padding(leftRight = 16.px)
    .styleModifier {
        property("outline", "none")
    }